export default "__VITE_ASSET__Cu$uTKFi__"